import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { WithDestroy } from '@lib/shared';
import { switchMap, takeUntil } from 'rxjs/operators';
import { MetadataService } from '../../../services/metadata.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-info-aside]',
  templateUrl: './info-aside.component.html',
  styleUrls: ['./info-aside.component.scss']
})
export class InfoAsideComponent extends WithDestroy() implements OnInit, OnDestroy {
  @Output() infoAsideClose: EventEmitter<any> = new EventEmitter<any>();

  public loanContacts: any[];
  public loan: any;
  public metaOrgUnit: any;
  public termsOfUseUrl = environment.termsOfUseUrl;
  public privacyPolicyUrl = environment.privacyPolicyUrl;

  constructor(private route: ActivatedRoute, private metadataService: MetadataService) {
    super();
  }

  ngOnInit() {
    this.metaOrgUnit = this.metadataService.metadata?.WizeOrgUnit;
    this.route.data
      .pipe(
        switchMap((data: any) => {
          return data.loan.valueChanges;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((loan: any) => {
        this.loan = loan;
        const primaryUsers = loan.users.filter((u) => u.primary === true);
        const originator = primaryUsers.find((item) => item.LoanRole === 'Originator');
        const owner = primaryUsers.find((item) => item.LoanRole === 'Owner');
        this.loanContacts = primaryUsers.filter((item) => item.LoanRole !== 'Originator' && item.LoanRole !== 'Owner');
        if (originator) {
          this.loanContacts.unshift(originator);
        } else if (owner) {
          owner.LoanRole = 'Originator';
          this.loanContacts.unshift(owner);
        }
      });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
